import { __exports as FiberManualRecord } from '../../../_virtual/FiberManualRecord.esm.js';
import { i as interopRequireDefaultExports } from '../../@babel/runtime/helpers/interopRequireDefault.esm.js';
import { __require as requireCreateSvgIcon } from './utils/createSvgIcon.esm.js';
import require$$2 from 'react/jsx-runtime';

var _interopRequireDefault = interopRequireDefaultExports;
Object.defineProperty(FiberManualRecord, "__esModule", {
  value: true
});
var default_1 = FiberManualRecord.default = void 0;
var _createSvgIcon = _interopRequireDefault(requireCreateSvgIcon());
var _jsxRuntime = require$$2;
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
  cx: "12",
  cy: "12",
  r: "8"
}), 'FiberManualRecord');
default_1 = FiberManualRecord.default = _default;

export { default_1 as default };
